import { FC, KeyboardEvent, useState } from 'react';
import Field from '../../../components/shared/Field/Field';
import { CellValue, parseCellInput } from './cellInput';
import styles from './customRowValueCell.module.scss';

type Props = {
  value: string;
  isText: boolean;
  unit?: string;
  readOnly: boolean;
  onSave: (value: CellValue) => void;
};

export const CustomRowValueCell: FC<Props> = ({ value, isText, unit, readOnly, onSave }) => {
  const [draft, setDraft] = useState(value);
  const shownUnit = isText ? undefined : unit;

  if (readOnly) return <span>{value}{value && shownUnit && <>&nbsp;{shownUnit}</>}</span>;

  const save = () => {
    const parsed = parseCellInput(draft, isText);
    setDraft(parsed.display);
    if (parsed.display !== value) onSave(parsed.value);
  };

  const blurOnEnter = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') e.currentTarget.blur();
  };

  return (
    <Field
      className={styles.cell}
      style={{ textAlign: isText ? 'left' : 'right' }}
      value={draft}
      onChange={setDraft}
      onBlur={save}
      onKeyDown={blurOnEnter}
      unit={shownUnit}
    />
  );
};
